module.exports = __webpack_public_path__ + "static/media/clock.278a1108.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clock.svg
// module id = 1263
// module chunks = 1